import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, AgCheckBoxEditor, AgTextAreaEditor, idNameItem, AgHtmlCellRenderer } from 'jk-service';
import { Mtrwb } from '../entity/Mtrwb-angular';

export const MtrWb028List = [{ id: "", name: "<空白>" }, { id: "JACKIE", name: "坤池" }, { id: "YAMEI", name: "雅美" }, { id: "CAMEL2", name: "駱駝2" }];
export const MtrWb012List = [{ id: "1", name: "1.最速件" }, { id: "2", name: "2.速件" }, { id: "3", name: "3.一般" }, { id: "4", name: "4.稍緩" }, { id: "5", name: "5.未確認規格" }, { id: "9", name: "9.未排定" }];

@Injectable({
  providedIn: 'root'
})
export class MtrwbServicePkg extends JkEntityV2 {
  MtrWb006List: idNameItem[] = [];
  MtrWb007List: idNameItem[] = [];
  MtrWb013List: idNameItem[] = [];
  MtrWb014List: idNameItem[] = [];
  MtrWb012List: idNameItem[] = MtrWb012List;


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Mtrwb();
    this.entityType.type = EntityType.master;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      WB001: '單別', WB002: '單號', WB003: '反應者代號', WB004: '單據日期', WB005: '反應者姓名', WB006: '部門', WB007: '類別', WB008: '程式代號', WB009: '程式名稱', WB010: '問題敘述說明', WB011: '處理說明', WB012: '處理順序', WB013: '狀態碼', WB014: '結案碼', WB015: '預計完工日', WB016: 'EMAIL', WB017: '實際工時', WB018: '報價工時', WB019: '訂單單號', WB020: '預計開工日', WB021: '交件日', WB022: 'User預計完工日', WB023: '序號', WB024: '客戶代號', WB025: '有附件', WB026: '已報價', WB027: '已回簽', WB028: '程式人員', WB029: '已交件', WB035: '附件數', WB036: '傑克程式說明', WB037: 'google文件網址'
    };

    this.fieldNames = 'WB001,WB002,WB003,WB004,WB005,WB006,WB007,WB008,WB009,WB010,WB011,WB012,WB013,WB014,WB015,WB016,WB017,WB018,WB019,WB020,WB021,WB022,WB023,WB024,WB025,WB026,WB027,WB028,WB029,WB035,WB036,WB037';
    this.fieldLengths = { WB001: 4, WB002: 11, WB003: 10, WB004: 8, WB005: 10, WB006: 10, WB007: 6, WB008: 10, WB009: 30, WB010: 0, WB011: 0, WB012: 1, WB013: 10, WB014: 1, WB015: 8, WB016: 80, WB017: 5.2, WB018: 5.2, WB019: 20, WB020: 8, WB021: 8, WB022: 8, WB023: 4, WB024: 20, WB025: 1, WB026: 1, WB027: 1, WB028: 10, WB029: 1, WB035: 6, WB036: 0, WB037: 255 };
    this.columnDefs = [
      { field: "WB002", headerName: "單號", headerTooltip: "", width: 90, cellDataType: "text", },
      { field: "WB004", headerName: "單據日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "WB005", headerName: "反應者姓名", headerTooltip: "", width: 90, cellDataType: "text", },
      { field: "WB009", headerName: "程式名稱", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "WB029", headerName: "交件", headerTooltip: "", width: 60, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WB010", headerName: "問題敘述說明", headerTooltip: "", width: 250, cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgHtmlCellRenderer, },
      { field: "WB022", headerName: "期望完工日", headerTooltip: "", width: 134, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "WB006", headerName: "分公司/部門", headerTooltip: "", width: 150, cellDataType: "text", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.MtrWb006List }, },
      { field: "WB012", headerName: "處理順序", headerTooltip: "", width: 150, cellDataType: "text", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.MtrWb012List }, },
      { field: "WB013", headerName: "狀態碼", headerTooltip: "", width: 150, cellDataType: "text", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.MtrWb013List }, },
      { field: "WB014", headerName: "結案碼", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WB011", headerName: "處理說明", headerTooltip: "", width: 250, cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgHtmlCellRenderer, },
      { field: "WB036", headerName: "傑克程式說明", headerTooltip: "", width: 250, cellDataType: "text",cellEditor: 'agLargeTextCellEditor', cellRenderer: AgHtmlCellRenderer, },
      { field: "WB008", headerName: "程式代號", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "WB016", headerName: "EMAIL", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "WB025", headerName: "有附件", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WB007", headerName: "類別", headerTooltip: "", width: 118, cellDataType: "text", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.MtrWb007List }, },
      { field: "WB015", headerName: "預計完工日", headerTooltip: "", width: 134, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "WB020", headerName: "預計開工日", headerTooltip: "", width: 134, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "WB021", headerName: "交件日", headerTooltip: "", width: 134, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "WB003", headerName: "反應者代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "WB035", headerName: "附件數", headerTooltip: "", width: 118, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "WB024", headerName: "客戶代號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "WB017", headerName: "實際工時", headerTooltip: "", width: 112, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "WB018", headerName: "報價工時", headerTooltip: "", width: 112, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "WB019", headerName: "訂單單號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "WB037", headerName: "附件網址", headerTooltip: "", width: 250, cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgHtmlCellRenderer, },
      { field: "WB023", headerName: "序號", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "WB026", headerName: "已報價", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WB027", headerName: "已回簽", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WB028", headerName: "程式人員", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "WB001", headerName: "單別", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "WB030", headerName: "預留欄位", headerTooltip: "", width: 80, cellDataType: "text", hide:true},
      { field: "WB031", headerName: "預留欄位", headerTooltip: "", width: 80, cellDataType: "text", hide:true},
      { field: "WB032", headerName: "預留欄位", headerTooltip: "", width: 150, cellDataType: "text", hide:true},
      { field: "WB033", headerName: "預留欄位", headerTooltip: "", width: 150, cellDataType: "text", hide:true},
      { field: "WB034", headerName: "預留欄位", headerTooltip: "", width: 150, cellDataType: "text", hide:true},
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'MTRWB';
    this.isSys = false;
    this.sqlSelect = `SELECT TOP 1000 MTRWB.*  FROM MTRWB`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY WB002 DESC,WB001`;
    this.keyFields = ['WB001', 'WB002'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['WB001', 'WB002', 'WB003', 'WB004', 'WB005', 'WB009', 'WB010', 'WB016', 'WB024'];
    this.seqField = 'WB002';
    this.seqFieldLength = 11;
  }
  override async validateItem(item: Mtrwb): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem: Mtrwb): Promise<Mtrwb> {
    await super.newRecord(newItem);
    return newItem;
  }




}

